import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { OepaUserAccount } from '@ohioepa/oepa-common-lib';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../../shared/api-response';

@Injectable({
  providedIn: 'root'
})
export class GWQCService {
  private rootURL = `${environment.webappsRootURL}`;
  private gwqcpURL = `${this.rootURL}/GWQCPWebApp/api/v1/gwqcp/`;
  private currentUserOHID: string | null = null;
  private currentUserAccount: OepaUserAccount | null = null;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {
  }

  getVersion() : Observable<ApiResponse<string>> {
    let foo: ApiResponse<string> = {
      data: '1.0.0',
      message: '',
      customValues: null
    };
    return of(foo);
  }

  getCurrentUserAccount(): Observable<OepaUserAccount> {
    return this.http.get<OepaUserAccount>(`${this.gwqcpURL}currentUserAccount`).pipe(
      tap({
        next: (account: OepaUserAccount) => {
          this.currentUserAccount = account;
        },
        error: err => {
          console.error('Error retrieving current user account:', err);
        }
      })
    );
  }

  public openSnackBar(message: string, action: string, severity: 'success' | 'info' | 'error') {
    if (severity == 'success') {
      this.snackBar.open(message, action, { horizontalPosition: 'center', duration: 5000, panelClass: ['green-snackbar'] });
    } else if (severity == 'info') {
      this.snackBar.open(message, action, { horizontalPosition: 'start', duration: 5000, panelClass: ['blue-snackbar'] });
    } else if (severity == 'error') {
      this.snackBar.open(message, action, { horizontalPosition: 'start', duration: 5000, panelClass: ['red-snackbar'] });
    }
  }

  setCurrentUserOHID(ohioid: string): void {
    this.currentUserOHID = ohioid;
  }

  getCurrentUserOHID(): string | null {
    return this.currentUserOHID;
  }

  getUserAccount() : OepaUserAccount | null {
    return this.currentUserAccount;
  }
}
